import React from "react";
import { BulletsData } from "../../data/bullets.data";
import IsPortrait from '../helpers/WindowOrientation';

import exitIcon from '../../assets/svgs/button_exit.svg'

interface BulletViewProps {
    car: any,
    bullet: any,
    showBulletMenu: boolean,
    setBullet: (value: any) => void;
    setShowBulletMenu: (value: boolean) => void;
}

const BulletView: React.FC<BulletViewProps> = ({ car, bullet, setBullet, showBulletMenu, setShowBulletMenu}) => {

  const [bullets, setBullets] = React.useState<any>(null);
  const [index, setIndex] = React.useState(0);
  const isPortrait = IsPortrait();

  React.useEffect(() => {

    if(!bullet || !car){
      setShowBulletMenu(false);
      return;
    }
    const bulletsData: any = BulletsData();
    /** EXTERNAL BULLETS **/
    let bullets = [];
    let selectedIndex = -1;
    let index = 0;
    for(const bulletEx of bulletsData[car.id].external){
      if(bulletEx.active === true){
        bullets.push(bulletEx)
        if(bulletEx.id === bullet.id){
          selectedIndex = index;
        }
      }
      index = index + 1;
    }
    if(selectedIndex > -1){
      setBullets(bullets);
      setIndex(selectedIndex);
      setShowBulletMenu(true);
      return;
    }
    /** INTERNAL BULLETS **/

    bullets = [];
    selectedIndex = -1;
    index = 0;
    for(const bulletIn of bulletsData[car.id].internal){
      if(bulletIn.active === true){
        bullets.push(bulletIn)
        if(bulletIn.id === bullet.id){
          selectedIndex = index;
        }
      }
      index = index + 1;
    }
    if(selectedIndex > -1){
      setBullets(bullets);
      setIndex(selectedIndex);
      setShowBulletMenu(true);
      return;
    }
    setShowBulletMenu(false);

  }, [car, bullet, setShowBulletMenu]);

  return (
    <div className={`bullet-full-container ${showBulletMenu ? '':'hide'} ${isPortrait ? 'portrait' : ''}`}>
      <div className={`bullet-sidebar-container ${isPortrait ? 'portrait' : ''}`}>
        <div className={`bullet-container ${showBulletMenu ? '':'hide'} ${isPortrait ? 'portrait' : ''}`}>
          
          { (bullets && index < bullets.length) && <div className={`bullet-container-content ${showBulletMenu ? '':'hide'} ${isPortrait ? 'portrait' : ''} ${(bullets && index < bullets.length && bullets[index].image) ? '' : 'empty'}`}>

            { bullets[index].image ?
              <div className={`bullet-container-banner ${isPortrait ? 'portrait' : ''}`} style={{ backgroundImage: `url(${bullets[index].image})` }}>
                {!isPortrait && <img className={`bullet-container-banner-button ${isPortrait ? 'portrait' : ''}`} src={exitIcon} alt='' onClick={() => {setBullet(null); setShowBulletMenu(false)}}/>}
              </div>
              :
              <div className={`bullet-container-banner-empty ${isPortrait ? 'portrait' : ''}`}>
                {!isPortrait && <img className={`bullet-container-banner-button empty ${isPortrait ? 'portrait' : ''}`} src={exitIcon} alt='' onClick={() => {setBullet(null); setShowBulletMenu(false)}}/>}
              </div>
            }
            
            <div className={`bullet-container-data ${isPortrait ? 'portrait' : ''}`}>
              {bullets[index].title && <div className={`bullet-container-title ${isPortrait ? 'portrait' : ''}`}>{bullets[index].title}</div>}
              <div className={`bullet-container-desc ${isPortrait ? 'portrait' : ''}`}>{bullets[index].text}</div>
            </div>

            {isPortrait && <img className={`bullet-container-banner-button ${isPortrait ? 'portrait' : ''}`} src={exitIcon} alt='' onClick={() => {setBullet(null); setShowBulletMenu(false)}}/>}

          </div>}
        </div>
      </div>
    </div>
  );
};

export default BulletView;
